import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { FaLinkedin, FaInstagram, FaFacebook, FaGithub } from "react-icons/fa";

export default function About() {
  const { loading, error, data } = useSelector((state) => state.portfolio);
  if (!data) return null;

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading About section</div>;

  return (
    <section id="about" className="py-20 bg-gray-50 dark:bg-gray-800">
      <div className="container mx-auto px-6 md:flex items-center gap-10">
        <motion.img
          src={data.myPic}
          alt="My profile"
          className="rounded-full w-48 h-48 object-cover shadow-lg mx-auto"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        />
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mt-6 md:mt-0"
        >
          <h2 className="text-3xl font-heading font-bold mb-4">About Me</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            {data.aboutDesc}
          </p>

          <div className="flex space-x-6 mt-6 text-gray-700 dark:text-gray-300 text-2xl">
            <a href={data.social.linkedIn} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href={data.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href={data.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook />
            </a>
            <a href={data.social.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
